
import React, { useEffect, useState } from 'react';
import useGet from '../Hooks/useGet';
import API_ENDPOINTS from '../Config/api';
import { useNavigate } from 'react-router-dom';

export default function Profilo() {
  const { fetchedData: aziendaDettagli, refetch: refetchAzienda } = useGet(API_ENDPOINTS.aziendaDettagli);
  const [form, setForm] = useState({
    nome_azienda: '',
    partita_iva: '',
    codice_fiscale: '',
    email: '',
    pec: '',
    url: '',
    indirizzo: '',
    cap: '',
    citta: '',
    comune: '',
    provincia: '',
    stato: '',
    telefono: '',
    numero_dipendenti: '',
    fatturato_annuo: '',
    id_settore: '',
    codice_ateco: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (aziendaDettagli) {
      setForm({
        nome_azienda: aziendaDettagli.nome_azienda || '',
        partita_iva: aziendaDettagli.partita_iva || '',
        codice_fiscale: aziendaDettagli.codice_fiscale || '',
        email: aziendaDettagli.email || '',
        pec: aziendaDettagli.pec || '',
        url: aziendaDettagli.url || '',
        indirizzo: aziendaDettagli.indirizzo || '',
        cap: aziendaDettagli.cap || '',
        citta: aziendaDettagli.citta || '',
        comune: aziendaDettagli.comune || '',
        provincia: aziendaDettagli.provincia || '',
        stato: aziendaDettagli.stato || '',
        telefono: aziendaDettagli.telefono || '',
        numero_dipendenti: aziendaDettagli.numero_dipendenti || '',
        fatturato_annuo: aziendaDettagli.fatturato_annuo || '',
        id_settore: aziendaDettagli.id_settore || '',
        codice_ateco: aziendaDettagli.codice_ateco || ''
      });
    }
  }, [aziendaDettagli]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setForm((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      // Se non ci sono file, invia JSON
      const hasFile = false; // logo non esiste più
      let response;
      if (!hasFile) {
        response = await fetch(API_ENDPOINTS.aziendaDettagli, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
          },
          body: JSON.stringify(form)
        });
      } else {
        // (non usato, ma lasciato per futuro upload file)
        const formData = new FormData();
        Object.entries(form).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== '') {
            formData.append(key, value);
          }
        });
        response = await fetch(API_ENDPOINTS.aziendaDettagli, {
          method: 'PATCH',
          headers: {
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
          },
          body: formData
        });
      }
      // Considera successo se status 200, 202, 204
      if (![200, 202, 204].includes(response.status)) {
        let errorText = '';
        try {
          errorText = await response.text();
        } catch (e) {
          errorText = '(no details)';
        }
        throw new Error('Errore salvataggio: ' + response.status + ' ' + errorText);
      }
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Errore nel salvataggio.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 w-full max-w-4xl max-h-[90vh] overflow-y-auto shadow-lg">
        <h2 className="text-2xl font-bold mb-6 text-yellow-700">Profilo Azienda</h2>
        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nome Azienda</label>
            <input type="text" name="nome_azienda" value={form.nome_azienda} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" required minLength="2" maxLength="255" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Partita IVA</label>
            <input type="text" name="partita_iva" value={form.partita_iva} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" pattern="[0-9]{11}" minLength="11" maxLength="11" title="Inserire una Partita IVA valida (11 cifre)" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Codice Fiscale</label>
            <input type="text" name="codice_fiscale" value={form.codice_fiscale} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" style={{ textTransform: 'uppercase' }} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$" title="Inserire un indirizzo email valido" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">PEC</label>
            <input type="email" name="pec" value={form.pec} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$" title="Inserire un indirizzo PEC valido" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Dominio Aziendale</label>
            <input type="text" name="url" value={form.url} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" title="Inserire il dominio aziendale" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Indirizzo</label>
            <input type="text" name="indirizzo" value={form.indirizzo} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">CAP</label>
            <input type="text" name="cap" value={form.cap} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" pattern="[0-9]{5}" minLength="5" maxLength="5" title="Inserire un CAP valido (5 cifre)" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Città</label>
            <input type="text" name="citta" value={form.citta} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Comune</label>
            <input type="text" name="comune" value={form.comune} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Provincia</label>
            <input type="text" name="provincia" value={form.provincia} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" pattern="[A-Z]{2}" minLength="2" maxLength="2" style={{ textTransform: 'uppercase' }} title="Inserire la sigla provincia (2 lettere maiuscole, es: RM, MI, NA)" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Stato</label>
            <input type="text" name="stato" value={form.stato} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Telefono</label>
            <input type="tel" name="telefono" value={form.telefono} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" pattern="[+]?[0-9\\s-]{6,20}" title="Inserire un numero di telefono valido (6-20 caratteri, può includere +, spazi e trattini)" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Numero Dipendenti</label>
            <input type="number" name="numero_dipendenti" value={form.numero_dipendenti} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" min="0" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Fatturato Annuo (€)</label>
            <input type="number" name="fatturato_annuo" value={form.fatturato_annuo} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" min="0" step="0.01" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Settore</label>
            <input type="text" value={aziendaDettagli?.nome_settore || ''} readOnly className="w-full p-2 border rounded bg-gray-100 cursor-not-allowed opacity-70" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Codice ATECO</label>
            <input type="text" name="codice_ateco" value={form.codice_ateco} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
          </div>
          {/* Messaggi di errore/successo */}
          <div className="col-span-2">
            {error && <div className="text-red-500 text-sm mb-2">{error}</div>}
            {success && <div className="text-green-500 text-sm mb-2">Salvataggio effettuato!</div>}
          </div>
          {/* Bottoni */}
          <div className="col-span-2 flex justify-end space-x-3 mt-6">
            <button
              type="button"
              className="flex items-center gap-2 bg-white text-gray-800 shadow-md hover:shadow-lg transition-all duration-300 px-3 py-2 rounded-md active:scale-95 disabled:opacity-50"
              onClick={() => navigate('/dashboard')}
              disabled={loading}
            >
              Indietro
            </button>
            <button
              type="submit"
              className="flex items-center gap-2 bg-yellow-500 text-white shadow-md hover:bg-yellow-600 hover:shadow-lg transition-all duration-300 px-5 py-2 rounded-md active:scale-95 disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Salvataggio...' : 'Salva'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
